import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSnackbar } from "notistack";
import { Navigate, useLocation, useNavigate } from 'react-router-dom';


interface IShipmentTypesContext {
    recordCount: number
    search: ISearch
    shipmentTypes: IShipmentType[]
    isLoading: boolean

    doSearch: (search: ISearch) => void
    handleChangePage: (event: any, page: number) => void
    updateSearch: (newSearch: ISearch) => void
    searchShipmentTypes: (searchRequest: ISearch) => Promise<void>
    deleteShipmentType: (shipmentTypeId: string) => Promise<void>
}

export let shipmentTypesContext = React.createContext<IShipmentTypesContext>({} as IShipmentTypesContext);

let { Provider } = shipmentTypesContext;

interface IShipmentType {
    shipmentTypeId: string
    code: string
    description: string
}

export interface ISearch {
    fullText: string

    pageNr: number
    pageSize: number
}

export let ShipmentTypesProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let { enqueueSnackbar } = useSnackbar();

    let location = useLocation();
    let navigate = useNavigate();

    let [isLoading, setLoading] = useState<boolean>(true);

    let [shipmentTypes, setShipmentTypes] = useState<IShipmentType[]>([]);
    let [recordCount, setTotalRecords] = useState(0);

    let [search, setSearch] = useState<ISearch>({
        fullText: '',
        
        pageNr: 0,
        pageSize: 20
    });

    useEffect(() => {
        if (location.state)
            processState(location.state);

    }, [location.state])


    if (!location.state)
        return <Navigate to={location.pathname} state={{ search: search }} replace={true} />


    let processState = (state: any) => {
        if (state) {

            setSearch({
                ...search,
                ...state
            });

            searchShipmentTypes({
                ...search,
                ...state
            });
        }
    }

    let doSearch = (values: ISearch) => {
        let request = {
            ...values,
            pageNr: values.pageNr > 0 ? 0 : values.pageNr
        }

        navigate(location.pathname, { state: request });
    }

    let updateSearch = (newSearch: ISearch) => {
        setSearch(newSearch);
    }

    let searchShipmentTypes = async (searchRequest: ISearch) => {
        try {
            setLoading(true);
            let response = await axios.post('/api/ShipmentType/SearchShipmentTypes', searchRequest);

            setShipmentTypes(response.data.items);
            setTotalRecords(response.data.recordCount);
            setSearch({ ...searchRequest });

        } catch (error) { }
        finally {
            setLoading(false);
        }
    }

    let handleChangePage = (event: any, page: number) => {
        let request = {
            ...search,
            pageNr: page
        }

        window.scrollTo(0, 0);
        navigate(location.pathname, { state: request });
    }


    let deleteShipmentType = async (shipmentTypeId: string) => {
        if (window.confirm("Are you sure you want to delete the shipment type?")) {
            try {
                await axios.delete(`/api/ShipmentType/DeleteShipmentType/${shipmentTypeId}`)
                enqueueSnackbar("Shipment Type deleted", { variant: 'success' });
                await doSearch({...search});
            } catch (error) { }
        }
    }

    return (
        <Provider value={{
            recordCount,
            search,
            shipmentTypes,
            isLoading,

            doSearch,
            handleChangePage,
            updateSearch,
            searchShipmentTypes,
            deleteShipmentType
        }}>
            {children}
        </Provider>
    );
};